
import React from 'react';
import ReactDOM from 'react-dom';
import * as ReactDOMClient from 'react-dom/client';
import App from './App';    
import Modal from 'react-modal';

export const isDevelopment = process.env.NODE_ENV === 'development';

Modal.setAppElement('#root');

const root = ReactDOMClient.createRoot(document.getElementById('root'));
root.render(
    <App />
);